import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { EmailTemplateNodeData } from "../node-types";
import { PanelEmailRecipient } from "./panel-email-recipient";
import { PanelEmailTemplate } from "./panel-email-template";

export function EmailActionNodePanel(
  props: NodePanelProps<EmailTemplateNodeData>,
) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelEmailTemplate />
      <PanelEmailRecipient />
    </PanelContainer>
  );
}
